import { useSearchParams } from 'react-router-dom';
import { getNavigationTarget } from '../../utils/returnTo/returnTo';

export const useReturnTo = (fallbackTo: string): string => {
  const [searchParams] = useSearchParams();
  const sanitizedReturnTo = getNavigationTarget(searchParams, 'returnTo');

  return sanitizedReturnTo ?? fallbackTo;
};
